import { render } from "./StudentAssistantView.vue?vue&type=template&id=5e34b408"
import script from "./StudentAssistantView.vue?vue&type=script&lang=js"
export * from "./StudentAssistantView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__